import Departure from '@/pages/departure';

export default Departure;
